import { useLDFlags } from "@shared/integration/launchdarkly"

// --------------------------------------------------------------------------------------------------------------------

export const FMG_ENOL_URL = `https://newclaims.fmg.co.uk/flock`

// --------------------------------------------------------------------------------------------------------------------

type Target = "_blank" | "_self" | "_parent" | "_top"

type ClaimsFlow =
  | Readonly<{ type: "internal" }>
  | Readonly<{
      type: "fmg"
      href: string
      target: Target
    }>
  | Readonly<{ type: "none" }>

// --------------------------------------------------------------------------------------------------------------------

export const useClaimsFlow = (): ClaimsFlow => {
  const { useInternalEfnol, useFmgEfnol } = useLDFlags()

  if (useInternalEfnol) return { type: `internal` }
  if (useFmgEfnol) return { type: `fmg`, href: FMG_ENOL_URL, target: `_blank` }

  return { type: `none` }
}
